import { IClient } from 'modules/models/client';
import { ClientModel, GeneralModel, UserModel } from '../../models';

export interface IState {
  onboardingClientMap: GeneralModel.IEntityMap<ClientModel.IClient>;
  clientMap: GeneralModel.IEntityMap<ClientModel.IClient>;
  clientHierarchyMap: ClientModel.IBranch;
  clientBranchesMap: ClientModel.IBranch;
  clientProjectMap: GeneralModel.IEntityMap<GeneralModel.IEntityMap<ClientModel.IClientProject>>;
  clientProjectHirearchyMap: GeneralModel.IEntityMap<ClientModel.IHirearchyClientProject>;
  mwbeList: GeneralModel.INamedEntity[];
  tradeList: GeneralModel.INamedEntity[];
  selfCompany: ClientModel.IClient;
  count: number;
  mergeCompanyUserMap: GeneralModel.IEntityMap<any>;
  mergeCompanySummaryMap: GeneralModel.IEntityMap<any>;
  mergeCompanyProjectSummaryMap: GeneralModel.IEntityMap<any>;
  isGeneralAdmin: boolean;
  userClients: GeneralModel.INamedEntity[];
  projectCompany: ClientModel.IClient;
  jointVentureUserMap: GeneralModel.IEntityMap<UserModel.IUser[]>;
  clientsToInvite: GeneralModel.IPagination<IClient>;
  failedTransactions: any;
  mergeCompanyBillingSummaryMap: GeneralModel.IEntityMap<any>;
  activeClients: GeneralModel.INamedEntity[];
  mergeCompanyInvoiceSummaryMap: GeneralModel.IEntityMap<any>;
  mergeCompanyReviewInvoiceSummaryMap: GeneralModel.IEntityMap<any>;
  mergeCompanyWorkersMap: GeneralModel.IEntityMap<any>;
  mergeCompanyInvoiceMap: GeneralModel.IEntityMap<any>;
  selectedProjects: any;
  selectedUsers: any;
  selectedWorkers: any;
  clientList?: GeneralModel.INamedEntity[];
}

export const initialState: IState = {
  onboardingClientMap: {},
  clientMap: {},
  clientHierarchyMap: null,
  clientBranchesMap: null,
  clientProjectMap: {},
  clientProjectHirearchyMap: {},
  mwbeList: [],
  tradeList: [],
  selfCompany: null,
  count: null,
  isGeneralAdmin: false,
  userClients: null,
  projectCompany: null,
  jointVentureUserMap: {},
  clientsToInvite: null,
  failedTransactions: null,
  mergeCompanySummaryMap: {},
  mergeCompanyProjectSummaryMap: {},
  mergeCompanyUserMap: {},
  mergeCompanyBillingSummaryMap: {},
  activeClients: null,
  mergeCompanyInvoiceSummaryMap: {},
  mergeCompanyWorkersMap: {},
  mergeCompanyInvoiceMap: {},
  selectedProjects: null,
  selectedUsers: null,
  selectedWorkers: null,
  mergeCompanyReviewInvoiceSummaryMap:{},
  clientList: [],
};
